import { IAttribute, IUser } from "./interface";

export const getActiveOrganizationDataSelector = (
  state: any
): IAttribute => {
  return state?.adminData?.organizationData?.userAttributes || {};
};

export const getActiveCollaborativeUserDataSelector = (state: any): IUser => {
  return state?.adminData?.userList || {};
};